import Colors from '@root/joinroot.com/src/utils/colors';
import ExpandableGroup from '@root/joinroot.com/src/components/sections/expandable/expandable-group';
import ExpandableItem from '@root/joinroot.com/src/components/sections/expandable/expandable-item';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { P1 } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';
import { pluralize } from '@root/core/src/utils/strings';

export default function FaqSearchResults({ filteredFaqData }) {
  const noMatches = filteredFaqData.length === 0;
  return (
    <div css={styles.faqResultsBlock}>
      <div css={styles.groupWrap}>
        <ExpandableGroup
          groupStyles={styles.expandableGroup}
          groupTitle={`${filteredFaqData.length} ${pluralize('match', filteredFaqData.length, 'matches')}`}
        >
          {noMatches && (
            <P1 css={styles.noMatchesBody}>
              Try searching for specific words, like &quot;coverage&quot; or &quot;claim&quot;.
            </P1>
          )}
          {filteredFaqData.map((item, i) => (
            <ExpandableItem
              itemTitle={item.title}
              key={i}
              openExpandableItem={true}
            >
              {item.content}
            </ExpandableItem>
          ))}
        </ExpandableGroup>
      </div>
    </div>
  );
}

FaqSearchResults.propTypes = {
  filteredFaqData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.object,
      plainText: PropTypes.string,
    })
  ),
};

const styles = StyleSheet.create({
  faqResultsBlock: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: '50px 20px 80px',
    backgroundColor: Colors.nearWhite(),

    ...Responsive.md({
      padding: '50px 30px 100px',
    }),
  },

  groupWrap: {
    width: '100%',

    ...Responsive.md({
      maxWidth: 1200,
      paddingLeft: 200,
    }),
  },

  expandableGroup: {
    maxWidth: '100%',
  },

  noMatchesBody: {
    marginTop: 30,
  },
});
